import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { Relay42Service } from '@app-core/services/relay42.service';
import { environment } from '@environments/environment';

@Directive({
  selector: '[relay42]'
})
export class Relay42Directive implements OnInit {
  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  relay42: { name?: string; data?: any } = {};

  constructor(private _relay42Service: Relay42Service) {}

  ngOnInit(): void {
    if (!this.relay42.name) {
      if (!environment.production)
        console.error(`[Relay42]: 'name' is required on directive`);
    }
  }

  @HostListener('click')
  onClick(): void {
    if (!this.relay42.name) return;
    this._relay42Service.publishEvent(
      'userinteractie/click',
      this.relay42.name,
      this.relay42.data
    );
  }
}
